import React, {Component} from 'react';
import {Row, Col} from 'react-flexbox-grid';
import PropTypes from 'prop-types';
import {GridList} from 'material-ui/GridList';
import Subheader from 'material-ui/Subheader';
import moment from 'moment';
import _ from 'lodash';
import DocumentPreview from './DocumentPreview';
import '../styles/GridList.css';
import './DocumentsList.css';
import IconButton from 'material-ui/IconButton';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import SelectionBar from '../components/SelectionBar';
import { getZipDownloadUrl } from '../services/FileStackService';
import * as fileSelectors from "../redux/files/selectors";
import {connect} from "react-redux";

function formatGroupDate(date) {
    const now = moment();
    const yesterday = moment().subtract(1, 'days');
    const d = moment(date, 'YYYYMMDD');

    if (d.isSame(now, 'day')) {
        return 'Today';
    }

    if (d.isSame(yesterday, 'day')) {
        return 'Yesterday';
    }

    if (d.isSame(now, 'week')) {
        return d.format('dddd');
    }

    if (d.isSame(now, 'year')) {
        return d.format('dddd, MMM D');
    }

    return d.format('dddd, MMM D, YYYY');
}

const mapStateToProps = (state) => ({
    filesList: fileSelectors.projectFiles(state),
});

class DocumentsList extends Component {

    static defaultProps = {
        filesList: {},
        filter: false
    };

    state = {
        groups: {},
        filesSearchList: [],
        barHidden: true,
        selectedFiles: []
    };

    // componentWillReceiveProps(nextProps) {
    //     const { filesSearchList, filesList } = nextProps;
    //
    //     if (nextProps === this.props) {
    //         return;
    //     }
    //
    //     if (this.state.filesSearchList !== nextProps.filesSearchList) {
    //         this.collectGroups();
    //     }
    //
    //     if (filesList !== this.props.filesList) {
    //         this.collectGroups();
    //     }
    // }

    componentDidMount() {
        this.collectGroups();
    }

    collectGroups = () => {
        const {filesList, searchEnabled, filesSearchList, onGroupsCollect, filteredFiles} = this.props;

        let files = filesList;

        if (filteredFiles) {
            files = filteredFiles;
        }

        if (Object.keys(files).length) {
            let filesListCopy = Object.assign({}, files);

            if (searchEnabled) {
                Object.keys(filesListCopy).map((file) => {
                    if (filesSearchList.indexOf(filesListCopy[file].id) === -1) {
                        delete filesListCopy[file];
                    }
                });
            }

            filesListCopy = _.sortBy(filesListCopy, (file) => file.createdAt).reverse();
            let groups = _.groupBy(filesListCopy, (file) => moment(file.createdAt).format('YYYYMMDD'));

            // this.setState({
            //     groups,
            //     filesSearchList
            // });

            if (typeof onGroupsCollect !== 'undefined') {
                onGroupsCollect(groups);
            }

            return {
                groups,
                filesSearchList
            }
        } else {
            return {
                groups: {}
            }
        }
    };

    renderDocuments = (documents) => {
        const {selectedFiles} = this.state;

        return documents.map((document, i) => {
            return (
            <DocumentPreview
                key={i}
                document={document}
                renderAsGridTile
                handleFileSelect={this._handleFileSelect}
                selectedFiles={selectedFiles}
            />
        )});
    };

    _renderSelectionBar = () => {
        const {barHidden, selectedFiles} = this.state;

        return (
            <SelectionBar
                hidden={barHidden}
                counter={selectedFiles.length}
                handleDownload={this._handleFilesDownload}
                handleClose={this._handleCloseSelectionBar}
            />
        );
    };

    _handleFileSelect = (document) => {
        const {selectedFiles} = this.state;
        const files = selectedFiles.slice();
        if (files.indexOf(document.filestackId) > -1) {
            files.splice(files.indexOf(document.filestackId), 1);
            if(files.length === 0){
                this._handleCloseSelectionBar();

                return;
            }
        } else {
            files.push(document.filestackId);
        }

        this.setState({selectedFiles: files, barHidden: false});
    };

    _handleSelectGroup = (documents, select = false) => {
        const {selectedFiles} = this.state;
        const files = selectedFiles.slice();

        if(select){
            documents.forEach((document) => {
                if (files.indexOf(document.filestackId) > -1) {
                    files.splice(files.indexOf(document.filestackId), 1);
                }
                files.push(document.filestackId);
            })
        } else {
            documents.forEach((document) => {
                if (files.indexOf(document.filestackId) > -1) {
                    files.splice(files.indexOf(document.filestackId), 1);
                }
                if(files.length === 0){
                    this._handleCloseSelectionBar();

                    return;
                }
            })
        }

        this.setState({selectedFiles: files, barHidden: false});
    };

    _handleFilesDownload = () => {
        const {selectedFiles} = this.state;
        if(selectedFiles.length === 0){
            return false;
        }

        const url = getZipDownloadUrl(selectedFiles);

        window.location.assign(url);
        this._handleCloseSelectionBar();
    };

    _handleCloseSelectionBar = () => {
        this.setState({selectedFiles: [], barHidden: true});
    };

    _renderGroupActionButton = (documents) => {
        const {selectedFiles} = this.state;
        let selected = false;

        if(selectedFiles.length > 0) {
            let copyOfFiles = selectedFiles.slice();
            let copyOfDocuments = [];

            documents.forEach((value) => {
                if (copyOfFiles.indexOf(value.filestackId) > -1) {
                    copyOfDocuments.push(value.filestackId)
                }
            });

            if(copyOfDocuments.length === documents.length){
                selected = true;
            }
        }

        let show = selected;

        let colors = {
            circleColor: "rgba(117,117,117, 1)",
        };

        if (selected) {
            colors.circleColor = "#4285f4";
        }

        let icon = (
            <CheckCircle
                color={colors.circleColor}
            />
        );

        if (!selected && selectedFiles.length > 0) {
            show = true;
        }

        return (
            <IconButton
                onClick={() => this._handleSelectGroup(documents, !selected)}
                className={`tile-selection-item ${show ? 'tile-selection-item-selected' : ''}`}
            >
                {icon}
            </IconButton>
        );
    };

    renderGroup = () => {
        const { groups } = this.collectGroups();


        const {filter} = this.props;
        let noDataText;

        const groupsData = Object.keys(groups).reverse().map((groupDate, i) => {
            // let documentsToRender = filter ? _.filter(groups[groupDate], (file) => file.type === filter) : groups[groupDate];
            let documentsToRender = filter ? _.filter(groups[groupDate], (file) => file.type === filter) : groups[groupDate];

            if (!filter) {
                documentsToRender = groups[groupDate];
                noDataText = 'files in';
            }
            if (filter === 'photo') {
                documentsToRender = groups[groupDate].filter(file => file.type === filter);
                noDataText = 'Photos in';
            }
            if (filter === 'Issues') {
                documentsToRender = groups[groupDate].filter(file => file.folder === filter);
                noDataText = 'Issue Reports in';
            }
            if (filter === 'Checklists') {
                documentsToRender = groups[groupDate].filter(file => file.folder === filter);
                noDataText = 'Checklist Reports';
            }
            if (filter === 'Specs') {
                documentsToRender = groups[groupDate].filter(file => file.folder === filter);
                noDataText = <span>Specs <span style={{ textDecoration: 'underline' }}>loaded</span> to</span>;
            }
            if (filter === 'Plans') {
                documentsToRender = groups[groupDate].filter(file => file.folder === filter || (file.type !== 'photo' && !file.folder));
                noDataText = <span>Plans <span style={{ textDecoration: 'underline' }}>loaded</span> to</span>;

            }
            if (filter === 'General') {
                documentsToRender = groups[groupDate].filter(file => file.folder === filter);
                noDataText = <span>General Files <span style={{ textDecoration: 'underline' }}>loaded</span> to</span>;
            }

            if (documentsToRender.length > 0) {
                return (
                    <Row key={`group-${groupDate}`}>
                        <Col xs={12}>
                            <Subheader className="grid-list-subheader">
                                {this._renderGroupActionButton(documentsToRender)}
                                <span>{formatGroupDate(groupDate)}</span>
                            </Subheader>
                            <GridList className="grid-list with-title-below highlightable" padding={16}>
                                {this.renderDocuments(documentsToRender)}
                            </GridList>
                        </Col>
                    </Row>
                )
            } else {
                return null;
            }
        }).filter(item => item);

        if (groupsData.length === 0) {
            return (
                <Row>
                    <Col xs={12}>
                        <Subheader className="grid-list-subheader">
                            <span>No {noDataText} {filter} yet</span>
                        </Subheader>
                    </Col>
                </Row>
            );
        }

        return groupsData;
    };

    render() {
        return (
            <Row start="xs" top="xs" className="documents-list grid-list-container">
                {this._renderSelectionBar()}
                <Col xs={12}>
                    {this.renderGroup()}
                </Col>
            </Row>
        )
    }
}

DocumentsList.propTypes = {
    filesList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    searchEnabled: PropTypes.bool,
    filesSearchList: PropTypes.array,
    onGroupsCollect: PropTypes.func,
    filter: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]),
    handleFileSelect: PropTypes.func
};


export default connect(mapStateToProps, {})(DocumentsList);